<router-outlet />

<p-toast></p-toast>
